// extracted by mini-css-extract-plugin
export default {"wrapper":"WorkQDeferredTooltip_wrapper__1iY6w","hover_loading":"WorkQDeferredTooltip_hover_loading__k2xCl"};